// VFX: Animated Grid Pattern
// Category: geometric-patterns · Tags: background, grid, dots, pattern, tech
// Grade de pontos ou linhas com fluxo animado. Estilo tech dashboard. Dark premium.
import { AbsoluteFill, useCurrentFrame } from "remotion";
import React from "react";

export interface AnimatedGridPatternProps {
  type?: "dots" | "lines" | "cross";
  color?: string;
  size?: number;
  dark?: boolean;
  flowDirection?: "up" | "right" | "diagonal";
}

export default function AnimatedGridPattern({
  type = "dots",
  color = "#a855f7",
  size = 32,
  dark = true,
  flowDirection = "up",
}: AnimatedGridPatternProps) {
  const frame = useCurrentFrame();
  const bg = dark ? "#060608" : "#f8fafc";
  const speed = 0.8;
  const offset = frame * speed;
  const patternSvg =
    type === "dots"
      ? `<circle cx="${size / 2}" cy="${size / 2}" r="1.5" fill="${encodeURIComponent(color)}" opacity="0.18"/>`
      : type === "lines"
      ? `<line x1="0" y1="${size / 2}" x2="${size}" y2="${size / 2}" stroke="${encodeURIComponent(color)}" stroke-width="0.5" opacity="0.14"/><line x1="${size / 2}" y1="0" x2="${size / 2}" y2="${size}" stroke="${encodeURIComponent(color)}" stroke-width="0.5" opacity="0.14"/>`
      : `<line x1="0" y1="0" x2="${size}" y2="${size}" stroke="${encodeURIComponent(color)}" stroke-width="0.5" opacity="0.12"/><line x1="${size}" y1="0" x2="0" y2="${size}" stroke="${encodeURIComponent(color)}" stroke-width="0.5" opacity="0.12"/>`;
  const svgData = `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}'>${patternSvg}</svg>`;
  const bgPos =
    flowDirection === "up"
      ? `0 ${-offset % size}px`
      : flowDirection === "right"
      ? `${offset % size}px 0`
      : `${offset % size}px ${-offset % size}px`;
  return (
    <AbsoluteFill style={{ background: bg }}>
      <div style={{ position: "absolute", inset: 0, backgroundImage: `url("${svgData}")`, backgroundPosition: bgPos, backgroundRepeat: "repeat" }} />
      <div style={{ position: "absolute", inset: 0, background: `radial-gradient(ellipse 80% 80% at 50% 50%, transparent 40%, ${bg} 90%)` }} />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
